module.exports = __webpack_public_path__ + "static/img/7.252ef6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/7.png
// module id = +Hw3
// module chunks = 0